import React, { useState, useEffect } from 'react'
import Modal from './Modal'

export default function Header({ scrollToSection, mapRef }) {
  const [isModalOpen, setIsModalOpen] = useState(false);


  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isVisible4, setIsVisible4] = useState(false);
  const [isVisible5, setIsVisible5] = useState(false);
  const [isVisible6, setIsVisible6] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setIsVisible1(true);
    }, 200); // 0.2 секунды

    const timer2 = setTimeout(() => {
      setIsVisible2(true);
    }, 400); // 0.4 секунды

    const timer3 = setTimeout(() => {
      setIsVisible3(true);
    }, 600); // 0.6 секунды

    const timer4 = setTimeout(() => {
      setIsVisible4(true);
    }, 800); // 0.8 секунды

    const timer5 = setTimeout(() => {
      setIsVisible5(true);
    }, 1000); // 1 секунда
    

     // 1 секунда

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
    };
  }, []);


  const openModal = () => {
    // Задержка 300 мс перед открытием модального окна
    setTimeout(() => {
      setIsModalOpen(true);
    }, 300);
  };
  const closeModal = () => setIsModalOpen(false);
  return (
    <header>
        <div className='logo_menu' >
            <div className='logo' > Гостевой дом «Эдельвейс»</div>
            <div className='menu'>
            <ul className='nav'>
              <li onClick={() => scrollToSection(mapRef)}>г. Керчь, ул. 23-го Мая д. 180 / ул Рыбакова,2а</li>




            </ul>
            <div className='contacts'>
          <span className='phone_number' >Телефон: <a href="tel:+79780116061"> +79780116061</a>
          </span>
           <a href="https://t.me/GostevojDomEdelweisKerch" target="_blank" rel="noopener noreferrer" className='telegram-link'>
  <img src="./img/telegram.png" alt="Telegram" width="32" height="32" className='telegram-icon'></img>
</a>

<a href="https://wa.me/qr/ZH5EL4M5ZPTJE1" target="_blank" rel="noopener noreferrer" className='whatsapp-link'>
  <img src="./img/whatsapp.png" alt="WhatsApp" width="32" height="32" className='whatsapp-icon'></img>
</a>
           </div>
            </div>
        </div>
        <div></div>
        
        <div className='presentation'>
          <div className='edelweis-logo'>
            <img src='./img/edelweis-logo1.png' alt="photo-logo" width="850" height="400"></img>
          </div>
          <div className='welcome' >Добро пожаловать к нам!</div>
            <div className='our_pluses' >
              <div className={`plus1 ${isVisible1 ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 20 20"><path fill="currentColor" d="M16.219 1.943c.653.512 1.103 1.339 1.287 2.205a.474.474 0 0 1 .065.026l2.045.946a.659.659 0 0 1 .384.597v12.367a.665.665 0 0 1-.85.634l-5.669-1.6l-6.74 1.858a.674.674 0 0 1-.371-.004L.474 17.217a.66.66 0 0 1-.474-.63V3.998c0-.44.428-.756.855-.632l5.702 1.661l2.898-.887a.734.734 0 0 1 .122-.025c.112-.656.425-1.286.95-1.9c.623-.73 1.716-1.158 2.781-1.209c1.105-.053 1.949.183 2.91.936ZM1.333 4.881v11.215l4.87 1.449V6.298l-4.87-1.417Zm8.209.614l-2.006.613v11.279l5.065-1.394v-3.295c0-.364.299-.659.667-.659c.368 0 .666.295.666.66v3.177l4.733 1.335V6.136l-1.12-.52c-.019.11-.043.218-.073.323A6.134 6.134 0 0 1 16.4 8.05l-2.477 3.093a.67.67 0 0 1-1.073-.037l-2.315-3.353c-.382-.534-.65-1.01-.801-1.436a3.744 3.744 0 0 1-.192-.822Zm3.83-3.171c-.726.035-1.472.327-1.827.742c-.427.5-.637.968-.679 1.442c-.05.571-.016.974.126 1.373c.105.295.314.669.637 1.12l1.811 2.622l1.91-2.385a4.812 4.812 0 0 0 .841-1.657c.24-.84-.122-2.074-.8-2.604c-.695-.545-1.22-.692-2.018-.653Zm.138.697c1.104 0 2 .885 2 1.977a1.988 1.988 0 0 1-2 1.977c-1.104 0-2-.885-2-1.977s.896-1.977 2-1.977Zm0 1.318a.663.663 0 0 0-.667.659c0 .364.299.659.667.659a.663.663 0 0 0 .666-.66a.663.663 0 0 0-.666-.658Z"/></svg>
                <div className='plus1_name'>Удобное расположение</div>
                </div>

                <div className={`plus2 ${isVisible2 ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 20 20"><path fill="currentColor" fillRule="evenodd" d="M10.001 14a2 2 0 1 1 0 4a2 2 0 0 1 0-4Zm0-3.853a5.695 5.695 0 0 1 4.8 2.626a.7.7 0 0 1-1.178.756a4.295 4.295 0 0 0-3.622-1.982a4.295 4.295 0 0 0-3.624 1.985a.7.7 0 0 1-1.179-.755a5.695 5.695 0 0 1 4.803-2.63Zm0-3.944c3.06 0 5.863 1.381 7.676 3.724a.7.7 0 0 1-1.107.857C15.02 8.783 12.626 7.603 10 7.603a8.283 8.283 0 0 0-6.537 3.184a.7.7 0 1 1-1.102-.863a9.682 9.682 0 0 1 7.64-3.721Zm0-4.203c3.905 0 7.243 1.5 9.819 4.32a.7.7 0 1 1-1.034.945C16.473 4.732 13.51 3.4 10.001 3.4c-3.422 0-6.453 1.372-8.79 3.87A.7.7 0 1 1 .19 6.316C2.785 3.538 6.184 2 10 2Z"/></svg>
                <div className='plus1_name'>Бесплатный wifi</div>
                </div>

                <div className={`plus3 ${isVisible3 ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48 " viewBox="0 0 24 24"><path fill="currentColor" d="M13.316 2.796a2.717 2.717 0 0 1 3.842 0l1.316 1.316l1.619-1.619l1.414 1.414l-1.619 1.619l1.316 1.316a2.717 2.717 0 0 1 0 3.842l-1.214 1.214c-.46.46-1.045.72-1.645.782a2.713 2.713 0 0 1-.782 1.646l-1.214 1.213c-.46.46-1.045.722-1.646.782a2.706 2.706 0 0 1-.782 1.646l-1.214 1.214a2.717 2.717 0 0 1-3.842 0L7.55 17.865l-1.618 1.619l-.708-.708a.717.717 0 1 0-.267 1.183l.943-.332l.665 1.887l-.944.332a2.717 2.717 0 1 1 .176-5.056l.339-.34l-1.316-1.315a2.717 2.717 0 0 1 0-3.842l1.214-1.214a2.705 2.705 0 0 1 1.646-.782c.06-.6.321-1.185.781-1.646l1.214-1.214a2.706 2.706 0 0 1 1.646-.781a2.708 2.708 0 0 1 .782-1.646l1.214-1.214Zm.2 3.641l4.047 4.047c.28.28.733.28 1.013 0L19.79 9.27a.717.717 0 0 0 0-1.014L18.474 6.94l-.974.974L16.086 6.5l.974-.974l-1.316-1.316a.717.717 0 0 0-1.014 0l-1.214 1.214a.717.717 0 0 0 0 1.013Zm2.632 5.46l-4.046-4.045a.717.717 0 0 0-1.013 0L9.875 9.065a.717.717 0 0 0 0 1.014l4.046 4.046c.28.28.734.28 1.014 0l1.213-1.214a.717.717 0 0 0 0-1.013Zm-3.641 3.643L8.46 11.492a.717.717 0 0 0-1.014 0l-1.214 1.214a.717.717 0 0 0 0 1.014l4.046 4.046c.28.28.734.28 1.014 0l1.214-1.214a.717.717 0 0 0 0-1.014Z"/></svg>
                <div className='plus1_name'>Барбекю зона</div>
                </div>

                

                <div className={`plus4 ${isVisible4 ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 16 16"><g fill="currentColor"><path d="M9 4H5v8h2v-2h2a3 3 0 1 0 0-6m0 4H7V6h2a1 1 0 0 1 0 2"/><path d="M15 1H1v14h14zM3 13V3h10v10z"/></g></svg>
                <div className='plus1_name'>Парковка</div>
                </div>

                <div className={`plus5 ${isVisible5 ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g fill="none"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="m17 10l-2-5c-2.167.833-6.8 5.8-6 13m22-8l2-5c2.167.833 6.8 5.8 6 13"/><path stroke="currentColor" strokeWidth="4" d="M42 28.5C42 38.165 33.941 43 24 43S6 38.165 6 28.5S14.059 9 24 9s18 9.835 18 19.5Z"/><circle cx="20" cy="17" r="2" fill="currentColor"/><circle cx="28" cy="17" r="2" fill="currentColor"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M24 26c0 1.657.5 5.5-3 5.5a3 3 0 0 1-3-3"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M24.025 26c0 1.657-.5 5.5 3 5.5a3 3 0 0 0 3-3"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="4" d="M26 25.75c0 .69-2 1.75-2 1.75s-2-1.06-2-1.75s.5-1.25 2-1.25s2 .56 2 1.25Z"/></g></svg>
                <div className='plus1_name'>C животными</div>
                </div>

            </div >
          <div className='reservation-height'>
          <div className={`reservation ${isVisible6 ? 'visible' : ''}`}>
      <h2>Забронируйте номер прямо сейчас!</h2>
      <button onClick={openModal} className="reservation-button">
        Забронировать
      </button>
      {/* Используем модальное окно */}
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </div>
          
        </div>
        </div>
    </header>
  )
  
}

